import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const CancelIcon = (props: any) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <circle
        cx="12"
        cy="12"
        r="8"
        fill="none"
        stroke="#000"
        strokeMiterlimit="10"
      />
      <path d="M15.9 7.4l-8.5 8.5.7.7 8.5-8.5-.7-.7z" />
      <path d="M8.1 7.4l-.7.7 8.5 8.5.7-.7-8.5-8.5z" />
    </SvgIcon>
  );
};

export default CancelIcon;
